// ── Welle D3c: Größe der Widget-Kachel für die Inhalte ──
// PC: w/h in Rasterzellen (4 Spalten, 176-px-Zeilen). Handy: klein = 1×1, groß = 2×2
// (Inhalte richten die Anzahl der Zeilen danach; am Handy wächst die Kachel mit).
import { createContext, useContext } from 'react';

export type WidgetGroesse = { w: number; h: number; geraet: 'pc' | 'handy' };
export const GroesseKontext = createContext<WidgetGroesse>({ w: 2, h: 2, geraet: 'handy' });
export const useWidgetGroesse = () => useContext(GroesseKontext);

/** Wie viele Listenzeilen passen: je Rasterzeile `proZeile`, am Handy klein/groß */
export function zeilenFuer(g: WidgetGroesse, proZeile: number, handyKlein = proZeile, handyGross = proZeile * 2) {
  if (g.geraet === 'handy') return g.w >= 2 ? handyGross : handyKlein;
  return Math.max(1, g.h * proZeile + (g.h - 1) * Math.round(proZeile / 2));
}
